import { ButtonComponentConfig, IconType } from '@rappider/rappider-components/utils';

export const CollapseAllButtonConfig: ButtonComponentConfig = {
  icon: {
    name: 'fas fa-minus',
    type: IconType.FontAwesome
  }
};
